import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import api from "../utilities/api";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check authentication status by calling the server
  const checkAuth = useCallback(async () => {
    try {
      const response = await api.get('/adminAuth/me');
      if (response.data.success) {
        setUser(response.data.data);
        setIsAuthenticated(true);
        // Store non-sensitive user info for UI purposes only
        localStorage.setItem("admin_addislearning_user", JSON.stringify(response.data.data));
      }
    } catch (error) {
      setUser(null);
      setIsAuthenticated(false);
      localStorage.removeItem("admin_addislearning_user");
    } finally {
      setChecked(true);
    }
  }, []);

  const login = useCallback((userData) => {
    // Token is now in HTTP-only cookie, only store user data
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem("admin_addislearning_user", JSON.stringify(userData));
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.get('/adminAuth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setUser(null);
      setIsAuthenticated(false);
      localStorage.removeItem("admin_addislearning_user");
    }
  }, []);

  useEffect(() => {
    // Restore user from localStorage for immediate UI, then verify with server
    const storedUser = localStorage.getItem("admin_addislearning_user");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        localStorage.removeItem("admin_addislearning_user");
      }
    }
    checkAuth();
  }, [checkAuth]);

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, checked, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}
